import './Dialog-8a809d11.css';

var classes = {"Backdrop":"prc-Dialog-Backdrop-ugYqZ","Dialog":"prc-Dialog-Dialog-luvDS","DisableScroll":"prc-Dialog-DisableScroll-F6LZa","DialogOverflowWrapper":"prc-Dialog-DialogOverflowWrapper-oDYJo","Footer":"prc-Dialog-Footer-jQfN4","Header":"prc-Dialog-Header-cjbcl","Title":"prc-Dialog-Title-oQ-W6","Subtitle":"prc-Dialog-Subtitle-sITpo","Body":"prc-Dialog-Body-LCvER"};

export { classes as default };
